export { ProfileInfoSection } from './ProfileInfoSection';
export { SubscriptionSection } from './SubscriptionSection';
export { CoursesSection } from './CoursesSection';
export { AppearanceSection } from './AppearanceSection';
export { LanguageSection } from './LanguageSection';
export { AudioSpeechSection } from './AudioSpeechSection';
export { AccountSection } from './AccountSection';
export { PrivacyLegalSection } from './PrivacyLegalSection';
export { SupportSection } from './SupportSection';
